import React from "react";

import "../dropdown/dropdown.css";

function DropDown() {
  window.onclick = function (event) {
    if (!event.target.matches(".dropbtn1")) {
      const dropdowns = document.getElementsByClassName("dropdown-content");
      let i;
      for (i = 0; i < dropdowns.length; i++) {
        let openDropdown = dropdowns[i];
        if (openDropdown.classList.contains("show")) {
          openDropdown.classList.remove("show");
        }
      }
    }
  };

  function showDropdown(e) {
    e.preventDefault();
    const dropdowns = document.getElementsByClassName("dropdown-content");
    let i;
    for (i = 0; i < dropdowns.length; i++) {
      let openDropdown = dropdowns[i];
      if (openDropdown.classList.contains("show")) {
        openDropdown.classList.remove("show");
      }
    }
    e.target.nextSibling.classList.toggle("show");
  }
  return (
    <>
      <div className="position_relative">
        <i className="material-icons more_icon dropbtn1" onClick={showDropdown}>
          more_vert
        </i>

        <div id="DropdownOpen" className="dropdown-content">
          <span>Modify Biller</span>
          <span>Delete Biller</span>
          <span>Set Reminders</span>
          <span>Enable Autoplay</span>
        </div>
      </div>
    </>
  );
}

export default DropDown;
